import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import { EVENTS_LIMIT } from "../../../../constants/picker-entries-constants";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getEventsChartStore from "../../../../stores/auditor-store/events-chart-store";
import getRootStore from "../../../../stores/core/root-store";
import Et3Date from "../../../../core/et3-input/et3-date";
import ET3Div from "../../../../core/et3-div";
import React from "react";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../../helpers/et3-picker-data-helper";

const EventsChartForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const allAdmins = getRootStore().allAdmins.get();
  const isEnabled = isPositiveNumber(
    reducerToZeroIfUndefined(
      parseInt(getEventsChartStore().adminInput.get().value, 10)
    )
  );

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("ADMIN")}
          options={allAdmins}
          value={getEventsChartStore().adminInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getEventsChartStore().setAdmin(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("TYPE")}
          options={[
            { label: "All", value: "all" },
            {
              label: "Approve/Reject Description",
              value: "approval_description"
            },
            {
              label: "Approve/Reject Peer Description",
              value: "approval_peer_description"
            },
            {
              label: "Approve/Reject Pictures",
              value: "approval_picture"
            },
            { label: "Report", value: "report" },
            {
              label: "Investigation Cases",
              value: "investigation_cases"
            }
          ]}
          value={getEventsChartStore().typeInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getEventsChartStore().typeInput.set(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={EVENTS_LIMIT}
          value={getEventsChartStore().limitInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getEventsChartStore().limitInput.set(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getEventsChartStore().dateMinInput}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} left={20} right={20} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getEventsChartStore().dateMaxInput}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={async () => await getEventsChartStore().getEventsChart()}
        isEnabled={isEnabled}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default EventsChartForm;
